import axios from 'axios';

export const loadProgramMembers = programId => (
	axios.get(`/provider_practice_programs/${programId}/provider_practice_program_members`, {
		params: {
			filter: JSON.stringify({
				where: {
					patientId: {
						neq: null
					}
				}
			})
		}
	})
);

const patientSort = (patient1, patient2) => {
	if (patient1.patient_name_last.trim() < patient2.patient_name_last.trim()) {
		return -1;
	} else if (patient1.patient_name_last.trim() === patient2.patient_name_last.trim()) {
		if (patient1.patient_name_first.trim() < patient2.patient_name_first.trim()) {
			return -1;
		} else if (patient1.patient_name_first.trim() === patient2.patient_name_first.trim()) {
			return 0;
		} else {
			return 1;
		}
	} else {
		return 1;
	}
};

export const loadPracticePanel = providerPracticeId => (
	new Promise((resolve, reject) => {
		axios.get(`/provider_practices/${providerPracticeId}/practice-panel`)
			.then(response => {
				const { practicePanel } = response.data.status;
				// remove non-unique patients
				const uniques = {};
				practicePanel.forEach(patient => {
					uniques[patient.patientId] = patient;
				});
				// sort last name, first name
				const data = Object.keys(uniques).map(patientId => uniques[patientId]);
				resolve(data.sort(patientSort));
			})
			.catch(err => reject(err));
	})
);

export const loadAttributeGroups = providerPracticeId => (
	new Promise((resolve, reject) => {
		axios.get(`/provider_practices/${providerPracticeId}/provider_practice_programs`)
			.then(({ data }) => resolve(data))
			.catch(err => reject(err));
	})
);

export const loadCareQuestGroups = providerPracticeId => (
	new Promise((resolve, reject) => {
		axios.get(`/provider_practices/${providerPracticeId}/care_quest_groups`, {
			params: {
				filter: JSON.stringify({
					where: {
						or: [
							{ inactive_ind: false },
							{ inactive_ind: null }
						]
					}
				})
			}
		})
		.then(({ data }) => resolve(data))
		.catch(err => reject(err));
	})
);

export const loadPatientAttributeGroupAssignments = (providerPracticeId, patientId) => (
	new Promise((resolve, reject) => {
		axios.get(`/provider_practices/${providerPracticeId}/provider_practice_program_members`, {
			params: {
				filter: JSON.stringify({
					where: {
						patientId
					}
				})
			}
		})
			.then(({ data }) => resolve(data))
			.catch(err => reject(err));
	})
);

export const loadPatientQuestionnaireGroupAssignments = (providerPracticeId, patientId) => (
	new Promise((resolve, reject) => {
		axios.get(`/provider_practices/${providerPracticeId}/care_quest_group_assignments`, {
			params: {
				filter: JSON.stringify({
					where: {
						patientId
					}
				})
			}
		})
			.then(({ data }) => resolve(data))
			.catch(err => reject(err));
	})
);

export const deletePatientAttributeGroupAssignment = ({ providerPracticeId, id }) => (
	axios.delete(`/provider_practices/${providerPracticeId}/provider_practice_program_members/${id}`)
);

export const addPatientAttributeGroupAssignment = ({ providerPracticeId, ...assignment }) => (
	axios.post(`/provider_practices/${providerPracticeId}/provider_practice_program_members`, {
		...assignment,
		providerPracticeId
	})
);

export const updatePatientAttributeGroupAssignment = ({ providerPracticeId, ...assignment }) => (
	axios.put(`/provider_practices/${providerPracticeId}/provider_practice_program_members/${assignment.id}`, {
		...assignment,
		providerPracticeId
	})
);


export const deleteQuestionnaireGroupAssignment = ({ providerPracticeId, id }) => (
	axios.delete(`/provider_practices/${providerPracticeId}/care_quest_group_assignments/${id}`)
);

export const addQuestionnaireGroupAssignment = ({ providerPracticeId, ...assignment }) => (
	axios.post(`/provider_practices/${providerPracticeId}/care_quest_group_assignments`, {
		...assignment,
		providerPracticeId
	})
);

export const getPracticeProviders = (providerId) => (
	new Promise((resolve, reject) => {
		axios.get(`/providers/${providerId}/practice-provider-list`)
		.then(({ data }) => resolve(data))
		.catch(err => reject(err));
	})
);
